import { type LocationArea } from '@/generated'
import { type GlobalLocation } from '@/lib/apollo/locationCache'

/**
 * Normalizes the location area returned by GetSearchResultsPageByUrl
 * */
export const getNormalizedLocationArea = (
  locationArea?: LocationArea | null
): GlobalLocation | undefined => {
  if (!locationArea) return

  return {
    latitude: locationArea.latitude,
    longitude: locationArea.longitude,
    radius: locationArea.radius,
    streetAddress: locationArea.address || '',
  }
}
